import axios from 'axios';

// API Base URL (v1 endpointleri için)
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/v1';

// Backend Base URL (static dosyalar için - /v1 olmadan)
export const BACKEND_URL = API_BASE_URL.replace('/v1', '');

// Resim URL'lerini tam URL'e çeviren yardımcı fonksiyon
export const getImageUrl = (path) => {
  if (!path) return null;
  // Eğer zaten tam URL ise aynen döndür
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  // Relative path ise backend URL'ini ekle
  return `${BACKEND_URL}${path}`;
};

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('bmk_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('bmk_token');
      if (window.location.pathname.startsWith('/admin') && 
          window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;

